import React from 'react';
import * as MyCells from '../../../../../utils/Cells';
import ActionMenu from '../../../../common/action/ActionMenu';
import DateRangeColumnFilter, { DateRangeColumnFilterFn } from '../../../../common/filters/DateRangeColumnFilter';
import TextColumnFilter from '../../../../common/filters/TextColumnFilter';

export const columns = (refresh) => {
    return [
        {
            Header: 'Sorszám',
            accessor: 'publicId',
            id: 'publicId',
            show: true,
            className: 'idColumn center',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Név',
            accessor: 'name',
            id: 'name',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Dátum',
            accessor: 'date',
            id: 'date',
            show: true,
            className: 'dateColumn',
            Filter: DateRangeColumnFilter,
            filter: DateRangeColumnFilterFn,
            Cell: props => <MyCells.DateCell value={props.value} />,
        },
        {
            Header: 'Kezdés időpont',
            accessor: 'startTime',
            id: 'startTime',
            show: true,
            className: 'timeColumn center',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Befejezés időpont',
            accessor: 'endTime',
            id: 'endTime',
            show: true,
            className: 'timeColumn center',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Összeg',
            accessor: 'amount',
            id: 'amount',
            show: true,
            className: 'right amountColumn',
            Filter: TextColumnFilter,
            Cell: props => <MyCells.NumberCell value={props.value} />,
        },
        {
            id: 'menu',
            show: true,
            headerClassName: 'actions',
            className: 'actions',
            Header: () => null, // No header
            Cell: value => <ActionMenu row={value.row.original} tabletype={'occasionalsalary'} refresh={refresh} />,
        },
    ]
}